<template>
  <div class="popup-title">
    <p class="title">{{ title }}</p>
    <img
      class="close"
      src="https://cdn.51ljb.cn/ljb_icons_pay_close.png"
      @click="closePopup">
    <!-- <van-icon name="cross" @click="closePopup" /> -->
  </div>
</template>

<script>
// import { Icon } from 'vant'

export default {
  name: 'PupopTitle',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    closePopup: function () {
      this.$emit('closePopup')
    }
  }
}
</script>

<style lang="scss" scoped>
.popup-title{
  position:relative;
  >i{
    position: absolute;
    font-size: 28px;
    color: #999999;
    right: $padding;
    top: $padding;
  }
}
.title{
  font-size: 18px;
  line-height: 70px;
  text-align: center;
}
.close{
  width: 15px;
  height: 15px;
  position: absolute;
  top:25px;
  right:$padding;

}
</style>



// WEBPACK FOOTER //
// src/components/title/PupopTitle.vue